<template>
  <a-tabs class="tab-chart" @change="changeTab">
    <a-tab-pane v-for="(value, index) in options" :key="index" :tab="value.title" force-render>
      <div class="chart-body" :ref="'chart' + index"></div>
    </a-tab-pane>
    <template #tabBarExtraContent>
      <div class="title">
        <div class="filter">
          <a-radio-group v-model="dateSelect" @change="changeDateSelect">
            <a-radio :value="1">日</a-radio>
            <a-radio :value="2">月</a-radio>
          </a-radio-group>
          <a-range-picker
            @change="changeData"
            v-model="dataRange"
            :format="dateSelect === 1 ? undefined : 'YYYY-MM'"
            :mode="dateSelect === 1 ? undefined : ['month', 'month']"
            :getCalendarContainer="triggerNode => triggerNode.parentNode"
            @panelChange="onPanelChange"
            @calendarChange="onCalendarChange"
            @openChange="onOpenChange"
            :disabled-date="disabledDate"
          ></a-range-picker>
          <a-select
            @change="changeData"
            mode="multiple"
            v-model="dataUsers"
            placeholder="请选择"
            :getPopupContainer="triggerNode => triggerNode.parentNode"
          >
            <a-select-option v-for="item in allUsers" :key="item.id" :value="item.id">{{
              item.realname
            }}</a-select-option>
          </a-select>
        </div>
      </div>
    </template>
  </a-tabs>
</template>
<script>
import * as echarts from 'echarts/core'
import { EN_DATE_SELECT } from '../index.vue'
import { message } from 'ant-design-vue'
import moment from 'moment'
export default {
  props: {
    range: {
      type: Array,
      default: function() {
        return []
      }
    },
    select: {
      type: Number,
      default: 0
    },
    selectedUsers: {
      type: Array,
      default: function() {
        return []
      }
    },
    allUsers: {
      type: Array,
      default: function() {
        return []
      }
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      charts: [],
      dataRange: [],
      dateSelect: EN_DATE_SELECT.MONTH,
      dataUsers: []
    }
  },
  created() {},
  mounted() {
    for (let index = 0; index < this.options.length; index++) {
      const chart = echarts.init(this.$refs[`chart${index}`][0], undefined, { height: 300 })
      this.charts.push(chart)
    }
    window.addEventListener('resize', this._resize)
  },
  destoryed() {
    window.removeEventListener('resize', this._resize)
  },
  computed: {},
  watch: {
    options: function() {
      this.renderChart()
    },
    range: function() {
      this.dataRange = this.range
    },
    select: function() {
      this.dateSelect = this.select
    },
    selectedUsers: function() {
      this.dataUsers = this.selectedUsers
    }
  },
  methods: {
    disabledDate(current) {
      if (!this.selectDate || this.selectDate.length === 0) {
        return false
      }
      const tooLate = this.selectDate[0] && current.diff(this.selectDate[0], 'days') > 15
      const tooEarly = this.selectDate[1] && this.selectDate[1].diff(current, 'days') > 15
      return tooEarly || tooLate
    },
    onOpenChange(open) {
      if (open) {
        this.selectDate = []
      }
    },
    onCalendarChange(val) {
      this.selectDate = val
    },
    onPanelChange(params) {
      if (params[1].diff(params[0], 'month') > 15) {
        message.warning('请选择少于15个月的区间')
        return
      }
      this.dataRange = params
      this.$emit('changeData', { select: this.dateSelect, range: this.dataRange })
    },
    async renderChart() {
      for (let index = 0; index < this.charts.length; index++) {
        const chart = this.charts[index]
        chart.setOption(this.options[index].option)
      }
    },
    changeDateSelect() {
      let start
      let end
      if (this.dateSelect === EN_DATE_SELECT.DAY) {
        end = moment('2022/06/30')
        start = moment('2022/06/30').add(-15, 'days')
      } else {
        end = moment().add(-1, 'months')
        start = moment().add(-12, 'months')
      }
      this.dataRange = [start, end]

      this.changeData()
    },
    changeData() {
      this.$emit('changeData', { select: this.dateSelect, range: this.dataRange, users: this.dataUsers })
    },
    changeTab(index) {
      this.$emit('changeTab', index)
    },
    _resize() {
      this.charts.forEach(chart => {
        chart.resize()
      })
    }
  }
}
</script>
<style lang="less">
.tab-chart {
  .ant-tabs-nav .ant-tabs-tab {
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    padding: 0 20px;
    font-weight: 600;
  }
}
</style>
